document.addEventListener("DOMContentLoaded", function () {

    var formsCounter = 0;
    const forms = document.querySelectorAll(".freeform-form");
    forms.forEach(form => {
        // Turnstile
        let turnstileScriptLoaded = false;
        let widgetId = null;
        const checkbox = form.querySelector('input[type=checkbox].form-input-captcha');

        const turnstileDiv = form.querySelector("div[data-freeform-turnstile-container=\"\"]");
        if(typeof turnstileDiv !== 'undefined') {
            // Submit Buttons disablen
            form.freeform.disableSubmit(".freeform-form button[type=submit]");

            formsCounter++;
            const turnstileId = "turnstile-" + formsCounter;
            turnstileDiv.setAttribute("id", turnstileId);
            const button = form.querySelector('button[type=submit]');

            if (typeof checkbox !== 'undefined' && checkbox !== null) {
                checkbox.addEventListener("change", function (e) {
                    if (e.target.checked) {
                        const registerTurnstile = () => {
                            turnstileScriptLoaded = true;
                            widgetId = turnstile.render('#' + turnstileId, {
                                callback: function (token) {
                                    if(typeof button !== 'undefined')  {
                                        button.removeAttribute('disabled');
                                    }
                                }
                            });

                            const ajaxTurnstileRefresh = function (event) {
                                turnstile.reset(widgetId);
                            }

                            // Freeform Logik zum Refreshen von Turnstile
                            form.addEventListener('freeform-ajax-success', ajaxTurnstileRefresh);
                            form.addEventListener('freeform-ajax-error', ajaxTurnstileRefresh);
                        };
                        // Falls Turnstile noch nicht geladen wurde, wird Script geladen und Registrierungslogik für gewählten Handler ausgeführt
                        if (!turnstileScriptLoaded) {
                            const script = document.createElement("script");
                            script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
                            script.async = true;
                            script.onload = registerTurnstile;
                            document.body.appendChild(script);
                        }
                        // Falls Turnstile bereits geladen wurde, wird Handler direkt ausgeführt
                        else {
                            registerTurnstile();
                        }
                    }
                    else {
                        if(widgetId !== null) {
                            turnstile.remove(widgetId);
                            button.setAttribute('disabled', '');
                        }
                    }
                });
            }
            form.addEventListener('submit', function (event) {
                if(typeof button !== 'undefined')  {
                    button.setAttribute('disabled', '');
                }
            })
        }
    });
});